import React from 'react';
import { Button } from '@/components/ui/button';

interface ErrorStateProps {
  onBack: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ onBack }) => {
  return (
    <div
      data-test-id="error-state"
      className="h-full bg-app-surface flex flex-col items-center justify-center p-4"
    >
      <p data-test-id="error-message" className="text-text-secondary mb-4">
        Competition not found
      </p>
      <Button data-test-id="go-back-btn" variant="secondary" onClick={onBack}>
        Go Back
      </Button>
    </div>
  );
};
